module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Code-0ee6eadaeaf91b9eb5cf64500655b3a8748133eb5d4c4e851c335c74d03af923.svg";